/* eslint-disable complexity */
import { TFunction } from 'i18next';

import { ILinkedCopier, IPelicanSectionSettings } from '@aqx-core/common/api/copy-trade';
import { ECopyTradeFilter, ECopyTradeTimeframe } from '@aqx-core/common/constants/copy-trade';
import { i18n } from '@aqx-core/common/i18n';
import storage, { EStorageKey } from '@aqx-core/common/storage';
import { compareArrays } from '@aqx-core/common/utils/array';

export const mapCopyTradeFilterToLabel = (filter: ECopyTradeFilter, t: TFunction = i18n.t) => {
  switch (filter) {
    case ECopyTradeFilter.EARLIER_COPIED:
      return t('Copied Strategies');
    case ECopyTradeFilter.ALL:
      return t('All Strategies');
    case ECopyTradeFilter.SPOTLIGHT:
      return t('Spotlight');
    case ECopyTradeFilter.GLOBAL_SIGNALS:
      return t('Global Strategies');
    case ECopyTradeFilter.MAX_DRAWDOWN:
      return t('Max Drawdown');
    case ECopyTradeFilter.TOP_FREE_SIGNALS:
      return t('Top Free Strategies');
    case ECopyTradeFilter.TOP_PAID_SIGNALS:
      return t('Top Paid Strategies');
    case ECopyTradeFilter.NEW_SIGNAL_PROVIDERS:
      return t('New Strategy Providers');
    case ECopyTradeFilter.HIGH_RISK:
      return t('High Risk');
    case ECopyTradeFilter.MEDIUM_RISK:
      return t('Medium Risk');
    case ECopyTradeFilter.LOW_RISK:
      return t('Low Risk');
    case ECopyTradeFilter.FAVOURITE_SIGNALS:
      return t('Favourite Strategies');
    case ECopyTradeFilter.STRATEGIES:
      return t('Strategies');
    case ECopyTradeFilter.COPIERS_PROFIT_YEAR:
      return t('Copiers Profit Year');
    case ECopyTradeFilter.COPIERS_PROFIT_MONTH:
      return t('Copiers Profit Month');
    case ECopyTradeFilter.COPIERS_BALANCE:
      return t('Copiers Balance');
    case ECopyTradeFilter.DEFAULT:
      return t('Default');
    default:
      return filter;
  }
};

export const isSelectedCopier = (copier: ILinkedCopier) =>
  copier.id === storage.getItem(EStorageKey.COPY_TRADE_SELECTED_COPIER_ID_KEY) && copier.isSelected;

export const isAccountHasSelectedCopier = (linkedCopiers: ILinkedCopier[]) =>
  linkedCopiers?.some(isSelectedCopier) ?? false;

export const compareColumnSettings = (
  newColumnSettings: IPelicanSectionSettings[],
  defaultColumnSettings: IPelicanSectionSettings[]
) => {
  return compareArrays(newColumnSettings, defaultColumnSettings, ['label', 'visible']);
};

export const mapTimeframe = (timeframe: ECopyTradeTimeframe, t: TFunction = i18n.t) => {
  switch (timeframe) {
    case ECopyTradeTimeframe.MONTHLY:
      return t('1M');
    case ECopyTradeTimeframe.WEEKLY:
      return t('1W');
    default:
      return t('1D');
  }
};
